"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClosure = exports.trackAnswer = exports.clearTrackedResponses = exports.getTrackedResponses = void 0;

var _FloatingFeedback = require("../components/FloatingFeedback");

var _cimpressCustomizr = require("cimpress-customizr");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getTrackedResponses = async (accessToken, sessionId) => {
  try {
    const client = new _cimpressCustomizr.CustomizrClient({});
    return await client.getSettings(accessToken, _FloatingFeedback.CUSTOMIZR_RESOURCE, sessionId);
  } catch (e) {// ignore
  }

  return {
    responses: []
  };
};

exports.getTrackedResponses = getTrackedResponses;

const putTrackedResponses = async (accessToken, data, sessionId) => {
  try {
    const client = new _cimpressCustomizr.CustomizrClient({});
    await client.putSettings(accessToken, data, _FloatingFeedback.CUSTOMIZR_RESOURCE, sessionId);
  } catch (e) {// ignore
  }
};

const clearTrackedResponses = async (accessToken, sessionId) => {
  try {
    const client = new _cimpressCustomizr.CustomizrClient({});
    await client.putSettings(accessToken, {
      responses: []
    }, _FloatingFeedback.CUSTOMIZR_RESOURCE, sessionId);
  } catch (e) {// ignore
  }
};

exports.clearTrackedResponses = clearTrackedResponses;

const trackAnswer = async (accessToken, data, campaignId, questionId, meta, sessionId) => {
  const answers = ((data || {}).responses || []).find(a => a.questionId === questionId && a.campaignId === campaignId);

  if (!answers) {
    data.responses.push({
      questionId,
      campaignId,
      answers: [{
        dateTime: (0, _moment.default)().toISOString(),
        meta: meta
      }]
    });
  } else {
    answers.answers.push({
      dateTime: (0, _moment.default)().toISOString(),
      meta: data
    });
  }

  await putTrackedResponses(accessToken, data, sessionId);
};

exports.trackAnswer = trackAnswer;

const trackClosure = async (accessToken, data, campaignId, questionId, sessionId) => {
  const answers = ((data || {}).responses || []).find(a => a.questionId === questionId && a.campaignId === campaignId);

  if (!answers) {
    data.responses.push({
      questionId,
      campaignId,
      answers: [{
        dateTime: (0, _moment.default)().toISOString(),
        meta: null
      }]
    });
  } else {
    answers.answers.push({
      dateTime: (0, _moment.default)().toISOString(),
      meta: data
    });
  }

  await putTrackedResponses(accessToken, data, sessionId);
};

exports.trackClosure = trackClosure;